var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainTopNavItemBox"},[_c('div',{staticClass:"rightMenuBox"},[_c('sidebar',{staticClass:"mainDropdownMenuBox floatLeft",attrs:{"color":_vm.color}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }